import { Paper, Typography } from '@mui/material';
import { FC } from 'react';
import { Payload } from 'recharts/types/component/DefaultTooltipContent';

type Props = {
  active?: boolean;
  payload?: Array<Payload<number, string>>;
  buildTooltipText?: (value?: number) => string;
};

export const DoughnutChartTooltip: FC<Props> = ({ active, payload, buildTooltipText }) => {
  if (!active || !payload) {
    return null;
  }

  const cellMetaData: { fill: string } | undefined = payload[0]?.payload as {
    fill: string;
  };

  return (
    <Paper
      elevation={2}
      sx={{
        paddingY: '5px',
        paddingX: '12px',
        borderRadius: '8px',
        borderLeft: cellMetaData ? `10px solid ${cellMetaData.fill}` : ''
      }}
    >
      <Typography variant="body1" fontWeight={'bold'}>
        {payload[0].name}
      </Typography>
      <Typography variant="body1">
        {buildTooltipText ? buildTooltipText(payload[0].value) : payload[0].value}
      </Typography>
    </Paper>
  );
};
